import authorization from 'shared/api/authorization'

export interface PostLoginProps {
  login: string
  password: string
}

export default async function PostLogin({ login, password }: PostLoginProps) {
  const body = {
    login,
    password,
  }

  try {
    return await authorization.post('/auth/login/', body)
  } catch (error) {
    return Promise.reject(error)
  }
}
